/** @jsx jsx */
import {jsx} from 'theme-ui'
import BackArrow from 'images/components/BackArrow.svg'
import {useTranslation, Trans} from 'react-i18next'

type Props = {
  handleBackClick: () => void
}

const ErrorBox: React.FC<Props> = ({handleBackClick}) => {
  const {t} = useTranslation()
  return (
    <div sx={{p: 20}}>
      <button
        onClick={handleBackClick}
        type="button"
        sx={{
          display: 'flex',
          alignItems: 'center',
          backgroundColor: 'transparent',
          border: 'none',
          fontSize: 16,
          lineHeight: '18px',
          color: 'soft',
          cursor: 'pointer',
        }}
      >
        <BackArrow sx={{mr: 12}} />
        Back
      </button>

      <h3
        sx={{
          textAlign: 'center',
        }}
      >
        {t('errorBoxTitle')}
      </h3>
      <p>{t('errorBoxParagraph1')}</p>

      <p>
        <Trans i18nKey="errorBoxParagraph2">
          If you still encounter donation issues, please send a message to
          <a href="mailto:contact@ummaty.org">contact@ummaty.org</a> and we will
          be happy to assist you.
        </Trans>
      </p>
    </div>
  )
}

export default ErrorBox
